import {
  BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY,
  BRIEF_LIST_QUERY_KEY,
  BRIEF_SUGGESTED_INFLUENCERS_QUERY_KEY,
} from "@entities/brief/lib/constants";
import { BriefService } from "@entities/brief/lib/services/brief.service";
import { INFLUENCER_SUGGEST_REQUEST_FACETS } from "@entities/influencer/lib/constants";
import { useMutation } from "@shared/lib/hooks";
import { PricingTrackerService } from "../services/pricing.tracker.service";
import { DOWNLOADS_LIST_QUERY_KEY } from "@entities/downloads/lib/constant";

export default function useDownloadPricingAnalytics() {
  const {
    mutate: downloadPricingAnalytics,
    isLoading: isDownloadingPricingAnalytics,
    isError: isDownloadingPricingAnalyticsError,
    isSuccess: isDownloadingPricingAnalyticsSuccess,
    error: downloadingPricingAnalyticsError,
  } = useMutation({
    mutationFn: (data: {
      from_to: {
        from: string;
        to: string;
      };
      assignedPricingPocs: string[];
      brandIds: string[];
      briefIds: string[];
    }) => PricingTrackerService.downloadPricingAnalytics(data),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c) => {
      setTimeout(() => {
        c.invalidateQueries({ queryKey: [DOWNLOADS_LIST_QUERY_KEY] });
      }, 1000);
    },
  });

  return {
    downloadPricingAnalytics,
    isDownloadingPricingAnalytics,
    isDownloadingPricingAnalyticsError,
    isDownloadingPricingAnalyticsSuccess,
    downloadingPricingAnalyticsError,
  };
}
